
import React, { useState } from "react";
import ConversationsListTags from "./ConversationsListTags";

function ConversationsList({
  conversations,
  onSelectConversation,
  selectedConversationId,
  availableTags,
  allConversations
}) {
  // Estado para controlar qué etiqueta está seleccionada (null significa "Todas")
  const [selectedTagId, setSelectedTagId] = useState(null);
  
  // 🔥 NUEVO: Estado para el input de búsqueda
  const [searchTerm, setSearchTerm] = useState("");

  function formatDate(timestamp) {
    return new Date(timestamp).toLocaleString("es-CO", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });
  }

  //Obtener el nombre del usuario desde localStorage para mostrarlo en el menú
  const userStorage = localStorage.getItem("user");
  let role = "";
  if (userStorage) {
    try {
      const userObj = JSON.parse(userStorage);
      role = userObj.role;
    } catch (error) {
      console.error("Error al parsear el usuario de localStorage:", error);
    }
  }
  
  // 🔥 LÓGICA DE FILTRADO ACTUALIZADA (Combina Etiquetas + Búsqueda)
 const filteredConversations = conversations
  .filter((conv) => {
    // 1. Verificar Etiqueta
    let matchesTag = true;

    if (selectedTagId) {
      if (selectedTagId === "from_ad") {
        matchesTag = conv.from_ad === 1;
      } else if (selectedTagId === "unread") {
        matchesTag = conv.unread_count > 0;
      } else if (selectedTagId === "ia") {
        matchesTag = conv.mode === "bot";
      } else if (selectedTagId === "human") {
        matchesTag = conv.mode === "human";
      } else {
        matchesTag = conv.tag_ids && conv.tag_ids.includes(selectedTagId);
      }
    }

    // 2. Verificar Búsqueda (Nombre o Teléfono)
    let matchesSearch = true;

    if (searchTerm.trim() !== "") {
      const term = searchTerm.toLowerCase();

      const nameMatch = conv.contact_name
        ? conv.contact_name.toLowerCase().includes(term)
        : false;

      const phoneMatch = conv.phone_number
        ? conv.phone_number.includes(term)
        : false;

      const dniMatch = conv.dni
        ? conv.dni.includes(term)
        : false;

      matchesSearch = nameMatch || phoneMatch || dniMatch;
    }

    return matchesTag && matchesSearch;
  })
  .sort((a, b) => {
    // Las conversaciones escaladas siempre primero
    if (a.escalated !== b.escalated) {
      return a.escalated === "yes" ? -1 : 1;
    }

    return 0;
  });

  // Calcular métricas para los badges
  // const conversationsFromAdCount = allConversations.filter(conv => conv.from_ad).length;
  // const conversationsLength = allConversations.length;
  // const unreadConversationsCount = allConversations.filter(conv => conv.unread_count > 0).length;  
  // const unreadConversationsFromAsesor1Count = allConversations.filter(conv => conv.unread_count > 0 && conv.user_id === 3).length;
  // const unreadConversationsFromAsesor2Count = allConversations.filter(conv => conv.unread_count > 0 && conv.user_id === 4).length;

  return (
    <div className="conversations-list">

      {/* <p style={{textAlign: 'left', color: '#888', fontStyle: 'italic', marginLeft: '10px'}}>
        {conversationsFromAdCount > 0 && (
          <span style={{color: '#6b7e7a', fontWeight: 'bold'}}>
            {conversationsLength} Total | {conversationsFromAdCount} Pauta | {conversationsLength - conversationsFromAdCount} Orgánico | {unreadConversationsCount} No leídas
          </span>
        )}
        {conversationsFromAdCount === 0 && "No hay conversaciones desde anuncios"}
      </p>

      {role === "admin" && (
        <p style={{textAlign: 'left', color: '#888', fontStyle: 'italic', marginLeft: '10px'}}>
          {conversationsFromAdCount > 0 && (
            <span style={{color: '#ad2513', fontWeight: 'bold'}}>
              {unreadConversationsCount} No leídas | {unreadConversationsFromAsesor1Count} Asesor1-Ruth | {unreadConversationsFromAsesor2Count} Asesor2-Natalia
            </span>
          )}
          {conversationsFromAdCount === 0 && "No hay conversaciones desde anuncios"}
        </p>
      )} */}

      <ConversationsListTags 
        tags={availableTags} 
        selectedTagId={selectedTagId}
        onTagClick={setSelectedTagId} 
      />

      {/* 🔥 NUEVO: Input de Búsqueda */}
      <div style={{ padding: "0 10px", marginBottom: "15px", marginTop: "10px" }}>
        <input
          type="text"
          placeholder="Buscar nombre o número..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "8px 12px",
            borderRadius: "6px",
            border: "1px solid #cbd5e1",
            outline: "none",
            fontSize: "14px",
            boxSizing: "border-box"
          }}
        />
      </div>

      <h2>Conversaciones {selectedTagId && "(Filtradas)"} : {filteredConversations.length}</h2>
      <ul>
        {filteredConversations.map((conv) => (
          <li
            key={conv.id}
            className={`conversation-item ${String(conv.id) === String(selectedConversationId) ? "selected" : ""}`}
            onClick={() => onSelectConversation(conv)}
          >
            <div className="conversation-name">{conv.contact_name}</div>
            <div className="conversation-phone">{conv.phone_number.slice(2)}</div>
            <div className="conversation-from-ad">{conv.mode === "bot" ? "⭐" : null }</div>
            <div className="conversation-icon">{conv.escalated === "yes" ? "🚨🚨🚨" : null }</div>
            {/* <div className="conversation-dni">{conv.dni}</div>  */}
            <div className="conversation-last-message">{conv.last_message}</div>
            <div className="conversation-timestamp">
              {formatDate(conv.last_message_at)}
            </div>
            <span
              className={`conversation-unread-count ${conv.unread_count > 0 ? "inline" : "hidden"}`}
            >
              {conv.unread_count}
            </span>
            
            <span className={`conversation-user`}>
              {conv.user_name ? conv.user_name : "Sin Asesor Asignado"}
            </span> 
          </li>
        ))}
        {filteredConversations.length === 0 && (
          <p style={{textAlign: 'center', color: '#888'}}>No se encontraron resultados.</p>
        )}
      </ul>
    </div>
  );
}

export default ConversationsList;